<template>
  <div class="page-container">
    <div class="edit-finalized-document__header">
      <div class="edit-finalized-document__header__title">
        <icon name="arrow-left" @click="goToFinalizedDocuments" />
        <h1 class="page-title">{{ title }}</h1>
      </div>
      <v-button :disabled="isLoading" @click="onDelete" outlined background-color="red">Izbriši</v-button>
    </div>
    <div class="page-subtitle-badge" v-if="finalizedDocument && !isBulkEditing">
      {{ finalizedDocument.name }} {{ finalizedDocument.description && ` - ${finalizedDocument.description}` }}
    </div>

    <div class="edit-finalized-document__loader" v-if="isDocumentCompositionLoading">
      <v-progress-spinner class="md-accent" :md-diameter="40" :md-stroke="3" md-mode="indeterminate" />
    </div>

    <template v-if="isDocumentCompositionAvailable">
      <document-composition :id="id" :is-editing="true" @document-loaded="isDocumentCompositionDocumentLoaded = true" />
      <br />
    </template>

    <finalized-document-form v-show="!isLoading" @submit="submitFinalizedDocument" @delete="onDelete" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DocumentComposition from '../../pages/document_composition/DocumentComposition' // TODO: move document composition outside pages into shared
import VButton from 'design-system/VButton.vue'
import VProgressSpinner from 'design-system/VProgressSpinner.vue'
import FinalizedDocumentForm from './forms/FinalizedDocumentForm'
import prompt from 'design-system/components/prompt/prompt'
import Icon from 'design-system/icons/Icon.vue'

export default {
  props: {
    id: { type: [String, Number], required: true },
    accountId: { type: [String, Number], required: true },
  },
  components: {
    DocumentComposition,
    FinalizedDocumentForm,
    VButton,
    VProgressSpinner,
    Icon,
  },
  beforeMount () {
    this.initialize({ accountId: this.accountId, finalizedDocumentIds: this.finalizedDocumentIds })
  },
  beforeDestroy () {
    this.reset()
  },
  data () {
    return {
      isDocumentCompositionDocumentLoaded: false,
    }
  },
  computed: {
    ...mapState(['isLoading']),
    ...mapState('accountStore/finalizedDocuments/forms', ['finalizedDocumentIds']),
    ...mapGetters(['accountSlug']),
    ...mapGetters('accountStore/finalizedDocuments/forms', ['finalizedDocument']),
    finalizedDocumentIds () {
      let finalizedDocumentIds = [this.id]
      if (typeof this.id === 'string' && this.id.includes(',')) {
        finalizedDocumentIds = this.id.split(',')
      }
      return finalizedDocumentIds
    },
    isBulkEditing () {
      return this.finalizedDocumentIds.length > 1
    },
    isDocumentCompositionLoading () {
      if (this.isLoading || !this.isDocumentCompositionAvailable) {
        return false
      }

      return !this.isDocumentCompositionDocumentLoaded
    },
    isDocumentCompositionAvailable () {
      return this.finalizedDocument && this.finalizedDocument.documentId != null && !this.isBulkEditing && this.finalizedDocument.editingStatus.canEdit === true
    },
    title () {
      return this.finalizedDocumentIds.length > 1 ? `Uredi dokumente (${this.finalizedDocumentIds.length})` : 'Uredi dokument'
    },
  },
  methods: {
    ...mapActions('accountStore/finalizedDocuments/forms', ['initialize', 'reset', 'submitFinalizedDocument', 'deleteFinalizedDocument']),
    async onDelete () {
      const result = await prompt.okText('Izbriši').confirm('Res želite izbrisati dokument? Akcija bo nepovratno izbrisala dokument.')
      if (result) {
        this.deleteFinalizedDocument(this.id).then(() => {
          this.$router.push({
            name: 'account_finalized_documents_path',
            params: {
              accountId: this.accountId,
            },
          })
        })
      }
    },
    goToFinalizedDocuments () {
      this.$router.push({
        name: 'account_finalized_documents_path',
        params: {
          accountId: this.accountSlug,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../common';

.edit-finalized-document__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.edit-finalized-document__header__title {
  display: flex;
  align-items: center;

  & .page-title {
    margin-bottom: 0;
  }

  & .icon-wrapper {
    display: flex;
    align-items: center;
    margin: 20px 16px 0 0;
    cursor: pointer;
  }
}

.edit-finalized-document__loader {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
</style>
